<template>
  <q-card class="q-pa-xs">
    <PackageAuth>
      <template #authorized-content>
        <div class="row q-pb-xs">
          <div class="justify-left q-gutter-sm">
            <q-radio
              v-model="timePeriod"
              val="hourly"
              label="Hourly"
              color="red"
              keep-color
            />
            <q-radio
              v-model="timePeriod"
              val="daily"
              label="Daily"
              color="cyan"
              keep-color
            />
            <q-radio
              v-model="timePeriod"
              val="weekly"
              label="Weekly"
              color="cyan"
              keep-color
            />
          </div>
        </div>

        <q-card flat bordered>
          <q-tabs
            v-model="tab"
            dense
            inline-label
            outside-arrows
            mobile-arrows
            :class="$q.dark.mode ? 'bg-grey-10' : 'text-grey-9 bg-grey-4'"
            active-color="white"
            :active-bg-color="$q.dark.mode ? 'grey-9' : 'blue-4'"
            :indicator-color="$q.dark.mode ? 'grey-7' : 'blue-5'"
            align="justify"
            narrow-indicator
          >
            <q-tab name="candlestick" label="Candlestick" no-caps />
            <q-tab name="true_candlestick" label="True Candlestick" no-caps />
          </q-tabs>

          <q-separator />

          <q-tab-panels v-model="tab" animated>
            <q-tab-panel class="q-pa-xs" name="true_candlestick">
              <TrueCandlestick
                @emittimeperiod="catchTimePeriod($event)"
                @clickSymbol="
                  (eSymbol) => {
                    symbol = eSymbol;
                  }
                "
                :timePeriod="timePeriod"
              />
            </q-tab-panel>
            <q-tab-panel class="q-pa-xs" name="candlestick">
              <Candlestick
                @emittimeperiod="catchTimePeriod($event)"
                @clickSymbol="
                  (eSymbol) => {
                    symbol = eSymbol;
                  }
                "
                :timePeriod="timePeriod"
              />
            </q-tab-panel>
          </q-tab-panels>
        </q-card>
      </template>
    </PackageAuth>
  </q-card>
</template>

<script setup>
import { ref, watchEffect } from "vue";
import { useQuasar } from "quasar";
import { useRoute } from "vue-router";

import TrueCandlestick from "src/components/TradingviewOverView/CandleStick/TrueCandleStick.vue";
import Candlestick from "src/components/TradingviewOverView/CandleStick/CandleStick.vue";

import PackageAuth from "src/components/Packages/PackageAuth.vue";

const emit = defineEmits(["chartSymbol","chartTimePeriod"]);

const $q = useQuasar();
const $route = useRoute();
const tab = ref($route.query?.type || "true_candlestick");
let timePeriod = ref("daily");
let symbol = ref("");
timePeriod.value = ref($route.query?.t || "daily")._value;

function catchTimePeriod(event) {}

watchEffect(() => {
  emit("chartTimePeriod", timePeriod.value);
  if (symbol.value && symbol.value !== "") {
    emit("chartSymbol", symbol.value);
  }
});
</script>
